define(['text!./templates/readonly-coverages.html'],
    (templateStr)=> {
        return [()=> {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    coverages: '=?gwQnbReadonlyCoverages',
                },
                controller: ['$scope', (scope)=> {
                    scope.selectedCoverages = scope.coverages.filter((coverage)=> {
                        return coverage.selected;
                    });
                }],
            };
        }];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/directives/ReadonlyCoverages.js